import { FAIcon } from "./faIcon.js";
import { FALayerIcon, FALayerIconPart } from "./faLayerIcon.js";
import { Helper } from "../util/helper.js";
import { MultiSelect } from "./multiSelect.js";
import { TextBox } from "./textBox.js";
import { CreateRequired } from "../../commonInterfaces.js";
import React from "react"

export class Button extends React.Component<ButtonProps, any>{
    constructor(props: ButtonProps) {
        super(props);
        
        const delay = props.throttleActive === true ? 1000 : 0;
        this._handleOnClick = Helper.throttle(this._handleOnClick, delay);
    }
    
    private isHovered = false;
    private btnRef: HTMLDivElement = null;

    private toggleColor = (on: boolean) => {
        if (this.props.readOnly !== true) {
            this.isHovered = on;
            this.setState({});
        }
    }

    private getBackgroundColor = () => {
        if (this.props.readOnly) {
            return "#FAFAFA";
        } else if (this.isHovered) {
            return "#ced3db";
        } else if (Helper.hasValue(this.props.inactiveState)) {
            return this.props.inactiveState === true ? "#FAFAFA" : "#C8C8C8";
        } else {
            return this.props.buttonStyle?.backgroundColor || "white";
        }
    }

    public static updateFocus = (refInput?: any) => {
        if (Helper.hasValue(refInput) && !Helper.useMobileGui()) {

            try {
                refInput.focus();
            }
            catch {
                var m = Object.keys(refInput).find(x => x == "udpateFocus");
                if (m != null) {
                    refInput[m]();
                }
            }
        }
    }
    private _handleOnClick = (e) => {
        e.preventDefault();
        if (this.props.readOnly !== true)
        {
            this.props.handleClick(e)
            Button.updateFocus(this.props.refInput);
        }
    }
    render() {
        let buttonStyle = $.extend({}, buttonDefaultStyle, this.props.buttonStyle);

        if (this.props.isInGroup && !this.props.isLastInGroup) {
            buttonStyle.borderRightWidth = "0px";
        }

        buttonStyle.cursor = this.props.readOnly ? "default" : "pointer";
        buttonStyle.backgroundColor = this.getBackgroundColor();
        buttonStyle.color = this.props.readOnly ? "#B9B9B9" : "black";
        let iconStyle: React.CSSProperties = {
            color: this.props.inactiveState || this.props.readOnly ? "#B9B9B9" : "black"
        };
        iconStyle = $.extend({}, iconStyle, this.props.iconStyle);

        return (
            <div
                ref={(r) => { this.btnRef = r }}
                title={this.props.title}
                id={this.props.id}
                style={buttonStyle}
                data-role="button"
                onMouseDown={(e) => { if (this.props.preventButtonFocus) { e.preventDefault(); } }}
                onClick={this._handleOnClick}
                onMouseEnter={() => this.toggleColor(true)} onMouseLeave={() => this.toggleColor(false)} >
                {
                    Array.isArray(this.props.layerIcons) ?
                        <FALayerIcon icons={this.props.layerIcons} style={iconStyle} />
                        :
                        <FAIcon name={this.props.iconName} sameWidth={true} style={iconStyle}></FAIcon>
                }

                {this.props.text}
            </div>
        );
    }
}

export const buttonDefaultStyle: React.CSSProperties = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: "white",
    width: "38px",
    minWidth: "32px",
    height: "38px",
    fontSize: "12pt",
    color: "var(--component-border-color)",
    borderColor: "#b3b3b3",
    borderStyle: "solid",
    borderLeftWidth: "1px",
    borderTopWidth: "1px",
    borderBottomWidth: "1px",
    borderRightWidth: "1px",
    paddingLeft: "5px",
    paddingRight: "5px"
};

interface IButtonProps extends React.PropsWithChildren {
    title?: string;
    iconName?: string;
    iconStyle?: React.CSSProperties;
    buttonStyle?: React.CSSProperties;
    handleClick(e?: React.MouseEvent<HTMLDivElement>);
    text?: string;
    readOnly?: boolean;
    inactiveState?: boolean;
    isInGroup?: boolean;
    isLastInGroup?: boolean;
    layerIcons?: Array<FALayerIconPart>;
    preventButtonFocus?: boolean;
    refInput?: any;
    id?: string;
    throttleActive?: boolean;
}

export type ButtonProps = CreateRequired<IButtonProps, "iconName"> | CreateRequired<IButtonProps, "layerIcons">;
